module.exports = __webpack_public_path__ + "images/img-3bsxC_m.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/ru/5.png
// module id = 2354
// module chunks = 0